import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Pool } from '../../models/pool';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { FormValidationService } from '../../../../shared/services/form-validation.service';



@Component({
  selector: 'app-pool-edit',
  template: require('./pool-edit.component.html'),
  styles: [require('./pool-edit.component.sass')]
})
export class PoolEditComponent implements OnInit {

  @ViewChild('poolEditModal') poolEditModal: ElementRef;
  @Input() projectId;
  @Output() savePool = new EventEmitter<Pool>();

  pool: Pool | undefined;
  poolForm: FormGroup;
  poolEditModalReference: NgbModalRef;

  constructor(
      private fb: FormBuilder,
      private modalService: NgbModal,
      public formValidation: FormValidationService
  ) {
  }

  ngOnInit(): void {
    this.poolForm = this.fb.group({
      name: ['', Validators.required],
      projectId: [{ value: '', disabled: true}, Validators.required],
      simPoolConfig: new  FormGroup(
          {
            limit: new FormControl(0, Validators.required),
            national: new FormControl(false)
          }
      )
    });
  }


  async showModal(pool?: Pool) {
    this.poolForm.reset();
    this.pool = pool;
    let poolData;
    if (this.pool) {
      poolData = {
        id: this.pool.id,
        name: this.pool.name,
        projectId: this.pool.projectId,
        simPoolConfig: {
          limit: this.pool.simPoolConfig.limit,
          national: this.pool.simPoolConfig.national,
          currentBeginPeriod: this.pool.simPoolConfig.currentBeginPeriod,
          currentEndPeriod: this.pool.simPoolConfig.currentEndPeriod
        }
      };
    } else {
      poolData = {
        projectId: this.projectId
      };
    }
    this.poolForm.patchValue(poolData);

    this.poolEditModalReference = await this.modalService.open(this.poolEditModal, {
      size: 'lg',
      backdrop: 'static'
    });
  }
  save = () => {
    if (this.poolForm.valid){
      const pool: Pool = {
        id: this.pool ? this.pool.id : undefined,
        ...this.pool,
        name: this.poolForm.value.name,
        projectId: this.projectId,
        simPoolConfig: {
          limit: this.poolForm.value.simPoolConfig && this.poolForm.value.simPoolConfig.limit,
          national: this.poolForm.value.simPoolConfig && this.poolForm.value.simPoolConfig.national,
        }
      };
      this.savePool.emit({ ...pool });
      this.poolEditModalReference.close();
    }else{
      this.formValidation.validateAllFormFields(this.poolForm);
    }
  }

  get name() { return this.poolForm.get('name'); }
  get description() { return this.poolForm.get('description'); }
  get abbreviation() { return this.poolForm.get('abbreviation'); }

  onKeyPressEvent(event: any, maxDigits: number) {
    if(isNaN(event.key)) {
      event.preventDefault();
    }

    if(event.target.value.length === maxDigits){
      event.preventDefault();
    }
  }

}
